
export default function Footer () {
  return (
    <section className='flex flex-col justify-center text-center'>
      <h1 className='mt-[35px] mb-0 mx-[10px]'>Want to get in contact?</h1>
      <section className='flex justify-evenly items-center py-[45px] px-0'>
        <section className='email'>
          <a
            href='mailto:jerricklc@gmail.com'
            className='flex flex-col place-items-center text-black no-underline'
          >
            <img
              src={process.env.PUBLIC_URL + 'images/email_icon.png'} alt='email_icon'
              className='w-[43px] h=[43px]'
            />
            <span className='text-center'>Email</span>
          </a>
        </section>
        <section className='linkedin'>
          <a
            className='flex flex-col place-items-center text-black no-underline'
            href='https://www.linkedin.com/in/jerricklc/'
            target='_blank' rel='noreferrer'
          >
            <img
              src={process.env.PUBLIC_URL + 'images/linkedin-logo.png'}
              alt='linkedin_icon'
              className=' w-[43px] h=[43px]'
            />
            <span className='text-center'>Linkedin</span>
          </a>
        </section>
        <section className='github'>
          <a
            className='flex flex-col place-items-center text-black no-underline'
            href='https://github.com/s0ysau'
            target='_blank' rel='noreferrer'
          >
            <img
              src={process.env.PUBLIC_URL + 'images/github-logo.png'} alt='github_icon'
              className='w-[43px] h=[43px]'
            />
            <span className='text-center'>Github</span>
          </a>
        </section>
        <section className='twitter'>
          <a
            className='flex flex-col place-items-center text-black no-underline'
            href='https://twitter.com/s0ysau'
            target='_blank' rel='noreferrer'
          >
            <img
              src={process.env.PUBLIC_URL + 'images/twitter-icon.png'} alt='twitter_icon'
              className='w-[43px] h=[43px]'
            />
            <span className='text-center'>Twitter</span>
          </a>
        </section>
        <section className='resume '>
          <a
            className='flex flex-col place-items-center text-black no-underline'
            href='https://drive.google.com/file/d/12HxdgwIpna5qOrGfT9RTseOUn8v6CL4N/view?usp=sharing'
            target='_blank' rel='noreferrer'
          >
            <img
              src={process.env.PUBLIC_URL + 'images/resume-icon.png'} alt='resume_icon'
              className='w-[43px] h=[43px]'
            />
            <span className='text-center'>Resume</span>
          </a>
        </section>
      </section>
      <p className='mb-[25px]'>Software Engineer and Project Management Professional</p>
    </section>
  )
}
